import type { BaseStoredPaymentMethod } from '@carvia/ros-client-types';
import { DateTime } from 'luxon';
import { i18n } from '@/i18n.ts';
import { formatDate } from '@/hooks/use-formatted-date';

export function formatStoredPaymentMethodLabel(
  method: Pick<BaseStoredPaymentMethod, 'purposes' | 'paymentType' | 'ccDetails' | 'createdAt'>,
): string {
  const t = i18n.global.t;
  const purposes = method.purposes.map((purpose) => t(`creditCard.${purpose}`)).join(', ');
  const type = method.paymentType
    ? t(`paymentTypes.${method.paymentType}`)
    : method.ccDetails?.brand;
  const last4 = method.ccDetails?.number;
  const details = last4
    ? method.ccDetails?.expiryDate
      ? ` ***-${last4} exp. ${method.ccDetails.expiryDate}`
      : ` ***-${last4}`
    : '';
  return `${purposes} ${type ?? ''}${details} (${formatDate(method.createdAt, DateTime.DATE_SHORT)})`;
}
